/* Preserve campaign parameters and honor explicit subscription links. */
(() => {
  const params = new URLSearchParams(window.location.search);
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const campaign = campaignKeys.filter(key => params.has(key));
  function preserveCampaign(root = document) {
    if (!campaign.length) return;
    root.querySelectorAll('a[href]').forEach(link => {
      const raw = link.getAttribute('href');
      if (!raw || /^(#|mailto:|tel:|javascript:)/i.test(raw)) return;
      let url;
      try { url = new URL(raw, window.location.href); } catch { return; }
      if (url.origin !== window.location.origin || /^\/(account|customer|cart|checkout|checkouts|admin|apps)(\/|$)/.test(url.pathname)) return;
      campaign.forEach(key => { if (!url.searchParams.has(key)) url.searchParams.set(key, params.get(key)); });
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }
  function start() {
    preserveCampaign();
    const linksObserver = new MutationObserver(() => preserveCampaign());
    linksObserver.observe(document.body, {childList: true, subtree: true});
    const requestedPlan = params.get('selling_plan');
    if (!requestedPlan || !/^\d+$/.test(requestedPlan)) return;
    let finished = false;
    let timer;
    const stop = () => { finished = true; clearTimeout(timer); planObserver.disconnect(); };
    const planObserver = new MutationObserver(selectRequestedPlan);
    function selectRequestedPlan() {
      if (finished) return;
      const radio = document.querySelector('.shopify_subscriptions_app_block input[data-selling-plan-id="' + requestedPlan + '"]');
      if (!radio || radio.disabled || radio.closest('.shopify_subscriptions_app_block').classList.contains('hidden')) return;
      if (!radio.checked) radio.click();
      stop();
    }
    document.addEventListener('change', event => {
      if (event.isTrusted && event.target.matches('.shopify_subscriptions_app_block input[type="radio"]')) stop();
    }, true);
    planObserver.observe(document.body, {childList: true, subtree: true});
    timer = setTimeout(stop, 10000);
    if (document.readyState === 'complete') selectRequestedPlan();
    else window.addEventListener('load', selectRequestedPlan, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
